<div class="pet-profile-form__wrapper">
  @let lifestageError = lifestageError$ | async;
  @let dateOfBirthError = dateOfBirthErrorMessage();

  <form [formGroup]="form" class="pet-profile-form__container">
    @if (isNewPet) {
      <div class="pet-profile-form__field-wrapper">
        <app-rc-radio-image
          [formControlName]="PetProfileFormValueKeysEnum.SPECIES_CODE"
          [items]="speciesItems"
          [label]="placeholders[PetProfileFormValueKeysEnum.SPECIES_CODE]"
          [error]="requiredErrorMessage(PetProfileFormValueKeysEnum.SPECIES_CODE, 'form-attribute_species')"
        ></app-rc-radio-image>
      </div>
      <div class="pet-profile-form__field-wrapper">
        <rc-field
          id="pet-profile-form-field-name"
          [formControlName]="PetProfileFormValueKeysEnum.NAME"
          type="text"
          [label]="'pet-page_patient-name' | translateKey"
          [error]="nameErrorMessage(PetProfileFormValueKeysEnum.NAME, 'form-attribute_name')"
        ></rc-field>
      </div>
    }
    @if (isNewPet || (initialBreedInvalid$ | async)) {
      <div class="pet-profile-form__field-wrapper__breed">
        @if (breeds$ | async; as breeds) {
          <rc-autocomplete
            [id]="'pet-profile-form-field-breed'"
            [attr.data-testid]="'pet-profile-form-field-breed'"
            [formControlName]="PetProfileFormValueKeysEnum.BREED"
            [placeholder]="placeholders[PetProfileFormValueKeysEnum.BREED]"
            [error]="requiredErrorMessage(PetProfileFormValueKeysEnum.BREED, 'form-attribute_breed')"
            [items]="breeds"
            [itemHeight]="itemHeight"
          ></rc-autocomplete>
          <div class="pet-profile-form__field-wrapper">
            <app-checkbox
              [formControlName]="PetProfileFormValueKeysEnum.MIXED"
              class="pet-profile-form__unknown-breed-checkbox"
              [label]="'form-attribute_select-unknown-or-mixed' | translateKey"
              [id]="'unknown-breed-checkbox'"
            ></app-checkbox>

            @if (form.controls.mixed.value) {
              <div
                class="pet-profile-form__field-wrapper__size"
                [ngClass]="breedInputNotNeeded ? 'pet-profile-form__field-wrapper__hide' : 'pet-profile-form__field-wrapper'"
              >
                <p class="pet-profile-form__field-label">{{ 'form-attribute_size' | translateKey }}</p>
                <rc-selectors
                  [id]="'breed-size-field-select'"
                  class="pet-profile-form__selectors"
                  [formControlName]="PetProfileFormValueKeysEnum.MIXED_BREED"
                  [items]="mixedDogBreeds"
                  [orientation]="'vertical'"
                ></rc-selectors>
              </div>
            }
          </div>
        }
      </div>
      <div class="pet-profile-form__field-wrapper datepicker-wrapper">
        <div class="field-wrapper" id="pet-profile-form-field-birthdate" [class.is-disabled]="form.controls.birthdate.disabled">
          @if (showDateFormatHint) {
            <p class="pet-profile-form__field-label">
              {{ dateFormatHint }}
            </p>
          }
          <div class="datepicker" [class.error-state]="lifestageError || dateOfBirthError">
            <input
              matInput
              appAutoFormatDate
              id="datepicker-input"
              class="error-input datepicker-input"
              autocomplete="off"
              [attr.data-testid]="'pet-profile-form-field-birthdate'"
              [formControlName]="PetProfileFormValueKeysEnum.BIRTHDATE"
              [max]="maxDate"
              [matDatepicker]="picker"
              [dateFormat]="dateFormat"
              [placeholder]="dateFormatHint"
              (input)="onBirthdateInputChange($event)"
            />
            <app-icon
              class="datepicker-icon"
              [class.error]="lifestageError || dateOfBirthError"
              [name]="IconName.calendar_small"
              (click)="picker.opened ? picker.close() : picker.open()"
            ></app-icon>
            <mat-datepicker #picker [startAt]="maxDate"></mat-datepicker>
          </div>
          @if (dateOfBirthError) {
            <div class="datepicker-error-message">{{ dateOfBirthError }}</div>
          }
        </div>
      </div>
      <app-checkbox
        [formControlName]="PetProfileFormValueKeysEnum.UNKNOWN_BIRTHDATE"
        class="pet-profile-form__unknown-birthdate-checkbox"
        [label]="'patient-page_unknown-birthdate' | translateKey"
        [id]="'unknown-birthdate-checkbox'"
      ></app-checkbox>
      @if (isCheckedUnknownBirthdate) {
        <div
          class="pet-profile-form__age-selector"
          [class.pet-profile-form__digit-counter--is-disabled]="form.controls[PetProfileFormValueKeysEnum.UNKNOWN_BIRTHDATE].disabled"
        >
          <div class="pet-profile-form__digit-counter">
            <rc-digit-counter
              [counterAriaLabel]="'aria_counter_field_number' | translateKey"
              [minusButtonAriaLabel]="'aria_counter_button_decrement' | translateKey"
              [plusButtonAriaLabel]="'aria_counter_button_increment' | translateKey"
              [formControlName]="PetProfileFormValueKeysEnum.AGE_COUNTER"
              [min]="minAgeCounter"
              [max]="maxAgeCounter"
              [editable]="true"
              [forceInputNumeric]="true"
            ></rc-digit-counter>
            <rc-selectors
              [id]="'age-field-select'"
              class="pet-profile-form__selectors"
              [formControlName]="PetProfileFormValueKeysEnum.AGE_UNIT"
              [mode]="'grouped'"
              [items]="AgeUnitItems"
            ></rc-selectors>
          </div>
          <div class="pet-profile-form__age-field-details">
            <ng-container [ngTemplateOutlet]="ageFieldDetails"></ng-container>
          </div>
        </div>
      }
      @if (lifestageError) {
        <span class="datepicker-error-message">{{ lifestageError }}</span>
      }
      @if (!isCheckedUnknownBirthdate) {
        <ng-container [ngTemplateOutlet]="ageFieldDetails"></ng-container>
      }
    }
    @if (isNewPet || (initialGenderInvalid$ | async)) {
      <div class="pet-profile-form__field-wrapper">
        <p class="pet-profile-form__field-label" [ngClass]="form.controls.gender.disabled ? 'disabled' : ''">
          {{ placeholders[PetProfileFormValueKeysEnum.GENDER] }}
        </p>
        <rc-selectors
          [id]="'pet-profile-form-field-gender'"
          class="pet-profile-form__selectors"
          [formControlName]="PetProfileFormValueKeysEnum.GENDER"
          [mode]="'grouped'"
          [items]="genderItems"
        >
          <ng-template let-item> <app-icon [name]="IconName[item.value]" class="selectors-icon"></app-icon></ng-template>
        </rc-selectors>
      </div>
    }
    <div class="pet-profile-form__field-wrapper">
      <p class="pet-profile-form__field-label" [ngClass]="form.controls.neutered.disabled ? 'disabled' : ''">
        {{ placeholders[PetProfileFormValueKeysEnum.NEUTERED] }}
      </p>

      <rc-selectors
        [id]="'pet-profile-form-field-neutered'"
        class="pet-profile-form__selectors"
        [formControlName]="PetProfileFormValueKeysEnum.NEUTERED"
        [mode]="'grouped'"
        [items]="neuteredItems"
      >
        <ng-template let-item>
          <app-icon [name]="item.value === 'true' ? IconName.success : IconName.fail" class="selectors-icon"></app-icon>
        </ng-template>
      </rc-selectors>
    </div>
    @if (
      displayPostSterilizationFeature &&
      (isPostSterilizationEnabled$ | async) &&
      form.controls.neutered.value === 'true' &&
      !patient?.pet?.neutered
    ) {
      <div class="pet-profile-form__field-wrapper">
        <p class="pet-profile-form__field-label">
          {{ placeholders[PetProfileFormValueKeysEnum.NEUTERED_TODAY] }}
        </p>
        <rc-selectors
          [id]="'pet-profile-form-field-neutered-today'"
          class="pet-profile-form__selectors"
          [formControlName]="PetProfileFormValueKeysEnum.NEUTERED_TODAY"
          [mode]="'grouped'"
          [items]="neuteredTodayItems"
        >
          <ng-template let-item>
            <app-icon [name]="item.value === 'true' ? IconName.success : IconName.fail" class="selectors-icon"></app-icon>
          </ng-template>
        </rc-selectors>
        <p id="pet-profile-form-neutered-today-disclaimer" class="pet-profile-form__post-sterilization-info-sentence">
          <app-icon [name]="IconName.info"></app-icon> {{ 'informational_sentence_post-sterilization' | translateKey }}
        </p>
      </div>
    }
    @if (form.controls.neuteredToday.value === 'true' && form.controls.gender.value === GenderCode.Female) {
      <div class="pet-profile-form__field-wrapper">
        <p class="pet-profile-form__field-label">
          {{ placeholders[PetProfileFormValueKeysEnum.STERILIZATION_TYPE] }}
        </p>
        <rc-selectors
          [id]="'pet-profile-form-field-surgery-type'"
          class="pet-profile-form__selectors"
          [formControlName]="PetProfileFormValueKeysEnum.STERILIZATION_TYPE"
          [mode]="'grouped'"
          [items]="sterilizationTypeItems"
        >
        </rc-selectors>
      </div>
    }
    @if (shouldDisplayReproductionStatus) {
      <div class="pet-profile-form__field-wrapper">
        <p class="pet-profile-form__field-label" [ngClass]="form.controls.reproductionStatus.disabled ? 'disabled' : ''">
          {{ 'pet-page_reproduction-cycle' | translateKey }}
        </p>
        <rc-selectors
          [id]="'pet-profile-form-field-reproduction'"
          class="pet-profile-form__selectors"
          [formControlName]="PetProfileFormValueKeysEnum.REPRODUCTION_STATUS"
          [mode]="'grouped'"
          [items]="reproductionStatusItems"
          [maxNumberGroupedItemsInHorizontal]="3"
        ></rc-selectors>
      </div>
    }
    @if (shouldDisplayWeeksOfPregnancy) {
      <section class="pet-profile-form__field-wrapper">
        <p class="pet-profile-form__field-label" [ngClass]="form.controls.reproductionStatus.disabled ? 'disabled' : ''">
          {{ 'weeks_of_gestation' | translateKey }}
        </p>

        <rc-selectors
          [id]="'pet-profile-form-field-weeks-of-pregnancy'"
          class="pet-profile-form__selectors pet-profile-form__selectors--pregnancy"
          [formControlName]="PetProfileFormValueKeysEnum.WEEKS_OF_PREGNANCY"
          [items]="pregnancyItems"
          [orientation]="'horizontal'"
        ></rc-selectors>
      </section>
    }
  </form>
  <div class="footer">
    <rc-button
      data-qa="vs-pet-profile-step-button-continue"
      id="validate-pet-information"
      type="button"
      [disabled]="(petProfileInvalidForTool$ | async) || form.invalid"
      (click)="submit()"
    >
      {{ submitButtonLabel }}
    </rc-button>
  </div>
</div>

<ng-template #ageFieldDetails>
  @if (tool === Tool.RenalDetect) {
    <p
      [class.is-disabled]="form.controls.birthdate.disabled && form.controls.unknownBirthdate.disabled"
      [ngClass]="lifestageError || dateOfBirthError ? 'datepicker-info__error' : 'datepicker-info'"
    >
      {{ 'rd_warning_pet-too-young' | translateKey }}
    </p>
  }
  @if (lifestageMessage$ | async; as message) {
    <div id="lifestage" class="lifestage">
      <app-icon class="lifestage-icon" [name]="IconName.alert"></app-icon>
      <span class="lifestage-info"> {{ message }} </span>
    </div>
  }
</ng-template>
